import { Check } from "lucide-react";
import { plans, WHATSAPP_NUMBER } from "@/lib/siteData";
import { Reveal } from "./Primitives";

export const Pricing = () => (
  <section id="planos" className="relative mx-auto max-w-7xl px-4 py-24 md:px-8 md:py-32">
    <Reveal className="mb-14 text-center">
      <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Planos</span>
      <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">
        Escolha e comece hoje
      </h2>
      <p className="mx-auto mt-4 max-w-xl font-body text-slate-400">
        Sem fidelidade, sem multa. Ative em 1 minuto e cancele quando quiser.
      </p>
    </Reveal>

    <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-3">
      {plans.map((p, i) => {
        const wa = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Olá! Quero assinar o plano ${p.name}.`)}`;
        return (
          <Reveal key={p.name} delay={i * 0.08}>
            <div
              data-testid={`plan-card-${p.name.toLowerCase()}`}
              className={`relative flex h-full flex-col rounded-3xl border p-8 transition-transform duration-300 ${
                p.highlight
                  ? "border-[#8B5CF6] bg-gradient-to-b from-[#8B5CF6]/15 to-[#0F0F1A] glow-purple md:scale-105"
                  : "border-white/8 bg-[#0F0F1A] hover:-translate-y-2"
              }`}
            >
              {p.badge && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#06B6D4] px-4 py-1 font-mono-accent text-[10px] font-bold uppercase tracking-widest text-white">
                  {p.badge}
                </span>
              )}
              <h3 className="font-display text-xl font-bold uppercase tracking-tight">{p.name}</h3>
              <div className="mt-4 flex items-end gap-1">
                <span className="font-body text-lg text-slate-400">R$</span>
                <span className="font-display text-5xl font-black tracking-tighter">{p.price}</span>
                <span className="mb-2 font-body text-sm text-slate-400">{p.period}</span>
              </div>
              <ul className="mt-7 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 font-body text-slate-300">
                    <Check className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#06B6D4]" /> {f}
                  </li>
                ))}
              </ul>
              <a
                data-testid={`plan-cta-${p.name.toLowerCase()}`}
                href={wa}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-8 inline-flex items-center justify-center rounded-full px-6 py-3.5 font-display font-bold transition-transform hover:scale-[1.03] ${
                  p.highlight
                    ? "bg-gradient-to-r from-[#8B5CF6] to-[#7c3aed] text-white"
                    : "border-2 border-white/15 text-white hover:border-[#8B5CF6]"
                }`}
              >
                Assinar {p.name}
              </a>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
